__turbopack_context__.v({
  "active": "WiMrca_active",
  "other": "WiMrca_other",
  "paragraph": "WiMrca_paragraph",
  "scroll-arrow-left": "WiMrca_scroll-arrow-left",
  "scroll-arrow-right": "WiMrca_scroll-arrow-right",
  "tab": "WiMrca_tab",
  "tabs": "WiMrca_tabs",
  "visible": "WiMrca_visible",
  "wrapper": "WiMrca_wrapper",
});
